module.exports = __webpack_public_path__ + "img/success.95ced681.png";